export default "__VITE_ASSET__2f6af94f__"